import { getSelectedBusinessId } from "selectors/businesses";
import { useMainApi } from "hooks";
import { useSelector } from "react-redux";
import MainApiRoutes from "const/MainApiRoutes";
import RestApi from "api/RestApi";

const useDocument = ({ documentId, fetchCondition = true }) => {
  const selectedBusinessId = useSelector(getSelectedBusinessId);

  const [{ results: documents }, documentsFetching] = useMainApi({
    method: RestApi.REQUEST_METHODS.POST,
    initialData: { results: [] },
    fetchCondition,
    parameters: [
      `${MainApiRoutes.BUSINESSES}/${selectedBusinessId}${MainApiRoutes.DOCUMENTS}`,
      null,
      { text: documentId }
    ],
    dependencies: [documentId, fetchCondition]
  });

  return { result: documents[0], fetching: documentsFetching };
};

export default useDocument;
